import { VariantForm } from "@/assets/interfaces";

type VariantOption = {
  image?: string;
  values: Record<string, string>;
  [key: string]: any;
};

type VariantsObject = {
  type: string;
  options: VariantOption[];
};

function pluralize(key: string): string {
  if (key.endsWith("y") && !/[aeiou]y$/.test(key)) {
    return key.slice(0, -1) + "ies";
  }
  return key + "s";
}

export function getVariantTypesAndCounts(variants: VariantForm): Record<string, number> {
  if (!variants || !variants.options || variants.options.length === 0 || !variants.type) return {};
  const result: Record<string, number> = {};
  const valueCounts: Record<string, Set<string>> = {};

  if (variants.type === "images") {
    const imageSet = new Set<string>();
    for (const option of variants.options) {
      if (option.image) {
        imageSet.add(option.image);
      }
      for (const [key, value] of Object.entries(option?.values ?? {})) {
        const pluralKey = pluralize(key.toLowerCase());
        if (!valueCounts[pluralKey]) {
          valueCounts[pluralKey] = new Set();
        }
        valueCounts[pluralKey].add(value);
      }
    }
    result["images"] = imageSet.size;
  } else {
    for (const option of variants.options) {
      for (const [key, value] of Object.entries(option.values)) {
        const pluralKey = pluralize(key.toLowerCase());
        if (!valueCounts[pluralKey]) {
          valueCounts[pluralKey] = new Set();
        }
        valueCounts[pluralKey].add(value);
      }
    }
  }

  for (const [key, set] of Object.entries(valueCounts)) {
    result[key] = set.size;
  }

  return result;
}
